import { render } from "./InvoicesList.vue?vue&type=template&id=44401b06&scoped=true"
import script from "./InvoicesList.vue?vue&type=script&lang=js"
export * from "./InvoicesList.vue?vue&type=script&lang=js"

import "./InvoicesList.vue?vue&type=style&index=0&id=44401b06&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44401b06"
/* hot reload */
if (module.hot) {
  script.__hmrId = "44401b06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44401b06', script)) {
    api.reload('44401b06', script)
  }
  
  module.hot.accept("./InvoicesList.vue?vue&type=template&id=44401b06&scoped=true", () => {
    api.rerender('44401b06', render)
  })

}

script.__file = "src/views/payments/modules/invoices/InvoicesList.vue"

export default script